<template>
  <div>
    <a @click="showingModal = true" class="button">
      <slot />
    </a>

    <QuoteRequestModal
        v-if="showingModal"
        @close="showingModal = false"
        class="quote-modal"
        :request_id="request_id"
    />
  </div>
</template>

<script>
import QuoteRequestModal from '@/components/Popups/QuoteRequest'

export default {
  components: { QuoteRequestModal },
  props: {
    request_id : Number
  },
  data () {
    return {
      showingModal: false,
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/QuoteRequestButton.vue